import GeneralServices from "./GeneralServices";
import { CatchErrorType } from "./dto/response/CommonResponse.dto";
import {
  GetRiskDataRequest,
  IGetHiringResponseOK,
  IGetPricesResponseOK,
  IGetRiskDataResponseOk,
  IResponseError,
  TravelHiringArgs,
} from "./TravelServices.dto";

class TravelServices {
  private handleError = (error: unknown, defaultMessage: string): IResponseError => {
    const typedError = error as CatchErrorType;
    const errorMsg = typedError.data && typedError.data.message;
    return {
      ok: false,
      message: typeof errorMsg === "string" ? errorMsg : defaultMessage,
    };
  };

  getRiskData = async ({
    setLoading,
    loader,
    request,
    internalName,
  }: {
    setLoading: Function;
    loader: boolean;
    request: GetRiskDataRequest;
    internalName: string;
  }): Promise<IGetRiskDataResponseOk | IResponseError> => {
    try {
      const response = await GeneralServices.post({
        setLoading,
        isSlowProcess: true,
        loader,
        endpoint: `sendaTravel/riskData?internalName=${internalName}`,
        data: request,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (err) {
      return this.handleError(
        err,
        "Se ha producido un error al obtener los datos de riesgo. Vuelva a intentarlo más tarde."
      );
    }
  };

  getPrices = async ({
    setLoading,
    loader,
    data,
  }: {
    setLoading: Function;
    loader: boolean;
    data: { COTIZACION: string };
  }): Promise<IGetPricesResponseOK | IResponseError> => {
    try {
      const response = await GeneralServices.post({
        setLoading,
        loader,
        isSlowProcess: true,
        endpoint: "sendaTravel/prices",
        data,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (err) {
      return this.handleError(
        err,
        "Se ha producido un error en la petición de precios. Vuelva a intentarlo más tarde."
      );
    }
  };

  hiring = async (args: TravelHiringArgs): Promise<IGetHiringResponseOK | IResponseError> => {
    try {
      const response = await GeneralServices.post({
        setLoading: args.setLoading,
        isSlowProcess: true,
        loader: true,
        endpoint: `sendaTravel/hiring`,
        data: args.data,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (err) {
      return this.handleError(
        err,
        "Se ha producido un error al enviar la petición. Vuelva a intentarlo más tarde."
      );
    }
  };
}

export default new TravelServices();
